import React, { useState } from 'react'
import Nav from './nav'
import Footer from './Footer'
import AdBanner from './AdBanner'
import NativeBanner from './NativeBanner'
export default function Contact() {
  const [hovered, setHovered] = useState(false)

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f8f9fa',
      fontFamily: 'Arial, sans-serif'
    },
    contactSection: {
      flex: 1,
      maxWidth: '800px',
      margin: '40px auto',
      padding: '40px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 2px 20px rgba(0,0,0,0.08)',
      lineHeight: '1.8',
      color: '#333',
      animation: 'fadeIn 0.5s ease-in'
    },
    heading: {
      textAlign: 'center',
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '30px',
      paddingBottom: '20px',
      borderBottom: '3px solid #007bff',
      position: 'relative'
    },
    headingUnderline: {
      position: 'absolute',
      bottom: '-3px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '50px',
      height: '3px',
      backgroundColor: '#007bff'
    },
    paragraph: {
      fontSize: '16px',
      marginBottom: '20px',
      color: '#555',
      lineHeight: '1.8'
    },
    highlight: {
      color: '#007bff',
      fontWeight: '600'
    },
    infoBox: {
      backgroundColor: '#f8f9fa',
      padding: '20px 25px',
      borderRadius: '8px',
      margin: '25px 0',
      borderLeft: '5px solid #007bff'
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      padding: '15px',
      marginBottom: '15px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      transition: 'all 0.3s ease'
    },
    contactItemHover: {
      backgroundColor: '#e9ecef',
      transform: 'translateX(5px)',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    },
    icon: {
      fontSize: '24px',
      width: '40px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#007bff',
      color: 'white',
      borderRadius: '50%',
      flexShrink: 0
    },
    contactInfo: {
      flex: 1
    },
    contactLabel: {
      fontSize: '14px',
      color: '#888',
      marginBottom: '2px'
    },
    contactValue: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#333'
    },
    contactValueLink: {
      color: '#007bff',
      textDecoration: 'none',
      fontSize: '18px',
      fontWeight: '600',
      transition: 'color 0.3s'
    },
    contactValueLinkHover: {
      color: '#0056b3',
      textDecoration: 'underline'
    },
    responseTime: {
      backgroundColor: '#fff3cd',
      padding: '15px 20px',
      borderRadius: '8px',
      borderLeft: '5px solid #ffc107',
      margin: '20px 0'
    },
    responseTimeText: {
      margin: 0,
      color: '#856404',
      fontSize: '15px'
    },
    socialLinks: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
      marginTop: '30px',
      paddingTop: '20px',
      borderTop: '1px solid #e9ecef'
    },
    socialLink: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '10px 20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      textDecoration: 'none',
      color: '#333',
      transition: 'all 0.3s ease',
      fontSize: '14px'
    },
    socialLinkHover: {
      backgroundColor: '#007bff',
      color: 'white',
      transform: 'translateY(-3px)',
      boxShadow: '0 4px 12px rgba(0,123,255,0.3)'
    },
    // Mobile Styles
    '@media (max-width: 768px)': {
      contactSection: {
        margin: '20px 15px',
        padding: '25px 20px'
      },
      heading: {
        fontSize: '24px'
      },
      paragraph: {
        fontSize: '14px'
      },
      contactItem: {
        padding: '12px',
        flexDirection: 'column',
        textAlign: 'center'
      },
      icon: {
        width: '50px',
        height: '50px',
        fontSize: '20px'
      },
      contactValue: {
        fontSize: '16px'
      },
      contactValueLink: {
        fontSize: '16px'
      },
      socialLinks: {
        flexDirection: 'column',
        alignItems: 'center'
      },
      socialLink: {
        width: '100%',
        justifyContent: 'center'
      }
    },
    '@media (max-width: 480px)': {
      contactSection: {
        margin: '15px 10px',
        padding: '20px 15px'
      },
      heading: {
        fontSize: '20px'
      },
      infoBox: {
        padding: '15px'
      },
      responseTime: {
        padding: '12px 15px'
      }
    }
  }

  return (
    <div style={styles.container}>
      <Nav />
              <AdBanner />
      <div style={styles.contactSection}>
        <h2 style={styles.heading}>
          Contact Us
          <span style={styles.headingUnderline}></span>
        </h2>
        
        <p style={styles.paragraph}>
          Thank you for visiting <strong style={styles.highlight}>APKNU.com</strong>. We value your feedback and are here to help you with any questions or concerns.
        </p>

        <div style={styles.infoBox}>
          <div style={styles.contactItem}>
            <div style={styles.icon}>📧</div>
            <div style={styles.contactInfo}>
              <div style={styles.contactLabel}>Email</div>
              <a 
                href="mailto:admin@apknu.com" 
                style={styles.contactValueLink}
                onMouseEnter={(e) => {
                  e.target.style.color = '#0056b3'
                  e.target.style.textDecoration = 'underline'
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#007bff'
                  e.target.style.textDecoration = 'none'
                }}
              >
                admin@apknu.com
              </a>
            </div>
          </div>

          <div style={styles.contactItem}>
            <div style={styles.icon}>📱</div>
            <div style={styles.contactInfo}>
              <div style={styles.contactLabel}>Phone</div>
              <a 
                href="tel:+923151962622" 
                style={styles.contactValueLink}
                onMouseEnter={(e) => {
                  e.target.style.color = '#0056b3'
                  e.target.style.textDecoration = 'underline'
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#007bff'
                  e.target.style.textDecoration = 'none'
                }}
              >
                +92 315 1962622
              </a>
            </div>
          </div>

          <div style={styles.contactItem}>
            <div style={styles.icon}>🌐</div>
            <div style={styles.contactInfo}>
              <div style={styles.contactLabel}>Website</div>
              <div style={styles.contactValue}>www.apknu.com</div>
            </div>
          </div>
        </div>
                <NativeBanner />
        <div style={styles.responseTime}>
          <p style={styles.responseTimeText}>
            ⏰ We try to respond to all support requests within <strong>24-48 hours</strong>.
          </p>
        </div>

        <p style={{...styles.paragraph, textAlign: 'center', marginTop: '20px'}}>
          You can also reach out to us through our social media channels:
        </p>

        <div style={styles.socialLinks}>
          <a 
            href="#" 
            style={styles.socialLink}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1877f2'
              e.target.style.color = 'white'
              e.target.style.transform = 'translateY(-3px)'
              e.target.style.boxShadow = '0 4px 12px rgba(24,119,242,0.3)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.color = '#333'
              e.target.style.transform = 'translateY(0)'
              e.target.style.boxShadow = 'none'
            }}
          >
            📘 Facebook
          </a>
          <a 
            href="#" 
            style={styles.socialLink}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1da1f2'
              e.target.style.color = 'white'
              e.target.style.transform = 'translateY(-3px)'
              e.target.style.boxShadow = '0 4px 12px rgba(29,161,242,0.3)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.color = '#333'
              e.target.style.transform = 'translateY(0)'
              e.target.style.boxShadow = 'none'
            }}
          >
            🐦 Twitter
          </a>
          <a 
            href="#" 
            style={styles.socialLink}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e4405f'
              e.target.style.color = 'white'
              e.target.style.transform = 'translateY(-3px)'
              e.target.style.boxShadow = '0 4px 12px rgba(228,64,95,0.3)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.color = '#333'
              e.target.style.transform = 'translateY(0)'
              e.target.style.boxShadow = 'none'
            }}
          >
            📸 Instagram
          </a>
        </div>
      </div>
              <AdBanner />
      <Footer />
    </div>
  )
}